import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6.667 1.333h18.666A2.667 2.667 0 0 1 28 4a.667.667 0 0 1-1.333 0c0-.736-.597-1.333-1.334-1.333H6.667a1.333 1.333 0 1 0 0 2.666h18.666A2.667 2.667 0 0 1 28 8v18.913a3.333 3.333 0 0 1-3.04 3.32c-3.268.29-6.25.434-8.945.434-2.698 0-5.69-.145-8.974-.434A3.333 3.333 0 0 1 4 26.912V4a2.667 2.667 0 0 1 2.667-2.667ZM16 26.667a25.5 25.5 0 0 1-5.582-.625 2.897 2.897 0 0 1-2.031-3.962l.455-1.067a3.333 3.333 0 0 1 2.499-1.976c1.434-.247 2.987-.37 4.659-.37 1.672 0 3.225.123 4.659.37a3.333 3.333 0 0 1 2.499 1.976l.455 1.067a2.895 2.895 0 0 1-2.03 3.963c-1.86.416-3.721.624-5.583.624Zm-4-13.334c0-2.208 1.793-4 4-4 2.208 0 4 1.794 4 4 0 2.208-1.793 4-4 4-2.208 0-4-1.793-4-4Z",
      clipRule: "evenodd"
    }
  )
);
var SvgContactsFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactsFilled_default = SvgContactsFilled;

export { ContactsFilled_default as default };
